import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Amex from '../../Assets/american_express.png';
import Visa from '../../Assets/visa_debit.png';
import MasterCard from '../../Assets/mastercard.png';
import StripeContainer from '../../Components/Payments/StripeContainer';
import { StyledButton } from '../../Components/Generics.styled';

const AboutYourBusinessViewContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ReviewInfoSection = styled.div`
    width: 100%;
    flex-direction: column;
    align-items: center;
    display: flex;
`;

const LoginTextFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    width: 100%;
    align-items: center;
`;
const WelcomeText = styled.div`
    text-align: center;
    letter-spacing: 0px;
    color: #343a40;
    opacity: 1;
    white-space: nowrap;
`;

const HelpText = styled(WelcomeText)`
    font-size: 21px;
`;

const NavigationSection = styled.div`
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const NavButtonBack = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
`;

const ReviewYourInfoContainer = styled.div``;

const Label = styled.div`
    text-align: left;
    letter-spacing: 0px;
    color: #707070;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const StyledValue = styled.span`
    letter-spacing: 0px;
    color: #000000;
    padding-left: 8px;
`;

const EnterPaymentInfoContainer = styled.div`
    width: 100%;
`;

const EnterPaymentInfo = styled.div`
    font-size: 24px;
    padding-top: 20px;
    font-weight: bold;
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`;

const EnterPaymentInfoBody = styled.div`
    display: flex;
    margin-top: 40px;
    height: 700px;
    margin-left: auto;
    margin-right: auto;
`;

const EnterPaymentInfoColumn = styled.div`
    display: flex;
    flex-direction: column;
    height: 700px;
    width: 450px;
    margin-left: auto;
    margin-right: auto;
`;

const PaymentHeaders = styled.div`
    font-weight: bold;
    font-size: 19px;
`;

const YourOrderSection = styled.div`
    /* margin-top: 10px; */
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    padding: 8px;
    width: 450px;
    border-bottom: 1px solid #d2d2d2;
`;

const PaymentMethodSection = styled.div`
    display: flex;
    flex-direction: column;
    height: 500px;
`;

const CreditCardSection = styled.div`
    border: 1px solid #3b88fc;
    height: 150px;
    background-color: #fafbf7;
    margin-top: 10px;
`;

const CreditCardRow = styled.div`
    display: flex;
`;

const CreditCardItem = styled.div`
    width: 200px;
    padding: 8px;
`;

const TermsSection = styled.div`
    height: 130px;
`;

const TellUsAboutYourBusinessView = ({
    aboutYourBusinessData,
    setAboutYourBusinessData,
    createNewAdvertiser,
    createACustomer,
    history,
    postData,
    setPostData,
}) => {
    const { error, isLoading } = { ...postData };

    const {
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        email,
        secondaryAddress,
        city,
        state,
        country,
        zipCode,
        accountType,
        planTypeName,
        planTypePrice,
        planTypeDuration,
        billingTermsIsChecked,
    } = { ...aboutYourBusinessData };

    const handleNavBackClick = () => {
        setPostData({ ...postData, error: null });
        history.push('/aboutYourBusiness/form');
    };

    const requiredFieldsAreEmpty =
        companyName === '' ||
        firstName === '' ||
        lastName === '' ||
        primaryPhone === '' ||
        mobilePhone === '' ||
        streetAddress === '' ||
        city === '' ||
        state === '' ||
        zipCode === '' ||
        planTypeName === '';

    // go back to the form on page refresh
    if (requiredFieldsAreEmpty) {
        history.push('/aboutYourBusiness/plan');
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const disableNextButton = !billingTermsIsChecked;

    return (
        <AboutYourBusinessViewContainer>
            <WelcomeText>Tell us about your business</WelcomeText>
            <br />
            <HelpText>Review Your information for accuracy.</HelpText>
            <ReviewInfoSection>
                <LoginTextFieldContainer>
                    <ReviewYourInfoContainer>
                        <Label>
                            Company Name:
                            <StyledValue>{companyName}</StyledValue>
                        </Label>

                        <Label>
                            Company Website:
                            <StyledValue>{companyWebsite}</StyledValue>
                        </Label>
                        <Label>
                            Email:
                            <StyledValue>{email}</StyledValue>
                        </Label>
                        <Label>
                            First Name:
                            <StyledValue>{firstName}</StyledValue>
                        </Label>
                        <Label>
                            Last Name:
                            <StyledValue>{lastName}</StyledValue>
                        </Label>
                        <Label>
                            Your Title:
                            <StyledValue>{title}</StyledValue>
                        </Label>
                        <Label>
                            Primary Phone:
                            <StyledValue>{primaryPhone}</StyledValue>
                        </Label>
                        <Label>
                            Mobile Phone:
                            <StyledValue>{mobilePhone}</StyledValue>
                        </Label>
                        <Label>
                            Street:
                            <StyledValue>{streetAddress}</StyledValue>
                        </Label>
                        <Label>
                            Secondary Address:
                            <StyledValue>{secondaryAddress}</StyledValue>
                        </Label>
                        <Label>
                            Country:
                            <StyledValue>{country}</StyledValue>
                        </Label>
                        <Label>
                            State:
                            <StyledValue>{state}</StyledValue>
                        </Label>
                        <Label>
                            City:
                            <StyledValue>{city}</StyledValue>
                        </Label>
                        <Label>
                            Zip:
                            <StyledValue>{zipCode}</StyledValue>
                        </Label>
                        <Label>
                            Account Type:
                            <StyledValue>{accountType}</StyledValue>
                        </Label>
                        <Label>
                            Plan Type:
                            <StyledValue>{`${planTypeName} - ${
                                planTypeDuration === 'monthly'
                                    ? `$${planTypePrice} billed monthly`
                                    : `$${planTypePrice} billed anually`
                            }`}</StyledValue>
                        </Label>
                    </ReviewYourInfoContainer>

                    <NavigationSection>
                        <StyledButton
                            onClick={() => handleNavBackClick()}
                            variant="contained"
                            color="primary"
                        >
                            Back
                        </StyledButton>
                        {/* <NavButtonConfirm
              onClick={() => createNewAdvertiser()}
              variant="contained"
              color="primary"
            >
              {isLoading ? (
                <CircularProgress
                  style={{ height: '20px', width: '20px', color: 'white' }}
                  color="primary"
                />
              ) : (
                'Place Order'
              )}
            </NavButtonConfirm> */}
                    </NavigationSection>
                    <br />
                    {error ? error.reason : null}
                </LoginTextFieldContainer>
            </ReviewInfoSection>

            <EnterPaymentInfoContainer>
                <EnterPaymentInfo>Create a Payment Method</EnterPaymentInfo>
                <EnterPaymentInfoBody>
                    {/* <EnterPaymentInfoColumn>
            <PaymentHeaders>BILLING DETAILS</PaymentHeaders>
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">Is the billing address the same as above?</FormLabel>
              <RadioGroup
                row
                aria-label="billing-address-same"
                name="row-radio-buttons-group"
                value={isBillingInfoSame}
                onChange={(e) => handleBillingInfoIsSame(e.target.value)}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            {isBillingInfoSame === 'No' ? (
              <>
                {' '}
                <StyledTextField
                  id="full-name"
                  label="Full Name"
                  defaultValue={billingName}
                  onChange={(e) =>
                    setAboutYourBusinessData({
                      ...aboutYourBusinessData,
                      billingName: e.target.value,
                    })
                  }
                  variant="outlined"
                  required
                  error={billingName === ''}
                />
                <br />
                <StyledTextField
                  id="billing-street-address"
                  label="Street Address"
                  defaultValue={billingStreetAddress}
                  onChange={(e) =>
                    setAboutYourBusinessData({
                      ...aboutYourBusinessData,
                      billingStreetAddress: e.target.value,
                    })
                  }
                  variant="outlined"
                  required
                  error={billingStreetAddress === ''}
                />
                <br />
                <StyledDropdown>
                  <FormControl required error={billingCountry === ''} variant="outlined">
                    <InputLabel id="billing-country-dropdown">Country</InputLabel>
                    <Select
                      style={{ width: '350px' }}
                      labelId="country-dropdown"
                      id="billing-country-dropdown"
                      value={billingCountry}
                      onChange={(e) =>
                        setAboutYourBusinessData({
                          ...aboutYourBusinessData,
                          billingCountry: e.target.value,
                          billingStateOrProvince: '',
                        })
                      }
                      label="country"
                    >
                      {countryCodes.map((item, idx) => (
                        <MenuItem key={idx} value={item}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </StyledDropdown>
                <StyledTextField
                  style={{ width: '350px' }}
                  id="billing-city"
                  label="City"
                  defaultValue={billingCity}
                  onChange={(e) =>
                    setAboutYourBusinessData({
                      ...aboutYourBusinessData,
                      billingCity: e.target.value,
                    })
                  }
                  variant="outlined"
                  required
                  error={billingCity === ''}
                />
                <br />
                <StyledDropdown>
                  <FormControl
                    disabled={billingCountry === ''}
                    required
                    error={billingCountry !== '' && billingStateOrProvince === ''}
                    variant="outlined"
                  >
                    <InputLabel id="state-or-province">
                      {billingCountry === 'USA' ? 'State' : 'Province'}
                    </InputLabel>
                    <Select
                      style={{ width: '350px' }}
                      labelId="state-or-province"
                      id="billing-state-or-province"
                      value={billingStateOrProvince}
                      onChange={(e) =>
                        setAboutYourBusinessData({
                          ...aboutYourBusinessData,
                          billingStateOrProvince: e.target.value,
                        })
                      }
                      label="state"
                    >
                      {billingCountry === 'USA'
                        ? stateCodes.map((item, idx) => (
                            <MenuItem key={idx} value={item}>
                              {item}
                            </MenuItem>
                          ))
                        : provinceCodes.map((item, idx) => (
                            <MenuItem key={idx} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </StyledDropdown>
                <StyledTextField
                  style={{ width: '350px' }}
                  id="zipcode"
                  label="Zipcode"
                  defaultValue={billingZipCode}
                  onChange={(e) =>
                    setAboutYourBusinessData({
                      ...aboutYourBusinessData,
                      billingZipCode: e.target.value,
                    })
                  }
                  variant="outlined"
                  required
                  error={billingZipCode === ''}
                />
                <br />
              </>
            ) : null}
          </EnterPaymentInfoColumn> */}
                    <EnterPaymentInfoColumn>
                        <PaymentHeaders>YOUR ORDER</PaymentHeaders>
                        <br />
                        <YourOrderSection>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>Product</div>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>
                                {planTypeName}
                            </div>
                        </YourOrderSection>
                        <YourOrderSection>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>Price</div>
                            <div
                                style={{ fontWeight: 'bold', fontSize: '13px' }}
                            >{`$${numberWithCommas(Number(planTypePrice).toFixed(2))}`}</div>
                        </YourOrderSection>
                        <YourOrderSection>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>Subscription</div>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>
                                {planTypeDuration}
                            </div>
                        </YourOrderSection>
                        <YourOrderSection>
                            <div style={{ fontWeight: 'bold', fontSize: '13px' }}>Total</div>
                            <div
                                style={{ fontWeight: 'bold', fontSize: '13px' }}
                            >{`$${numberWithCommas(Number(planTypePrice).toFixed(2))}`}</div>
                        </YourOrderSection>
                        <br />
                        <PaymentMethodSection>
                            <PaymentHeaders style={{ fontSize: '14px' }}>
                                PAYMENT METHOD
                            </PaymentHeaders>

                            <CreditCardSection>
                                <CreditCardRow style={{ justifyContent: 'space-between' }}>
                                    <CreditCardItem style={{ color: '#707070', fontSize: '16px' }}>
                                        <RadioGroup
                                            aria-label="payment-method"
                                            defaultValue="creditCard"
                                            name="radio-buttons-group"
                                        >
                                            <FormControlLabel
                                                value="creditCard"
                                                control={<Radio />}
                                                label="Credit Card"
                                            />
                                        </RadioGroup>
                                    </CreditCardItem>
                                    <CreditCardItem style={{ textAlign: 'right' }}>
                                        <img alt="visa" src={Visa} />

                                        <img alt="amex" src={Amex} />
                                        <img alt="masterCard" src={MasterCard} />
                                    </CreditCardItem>
                                </CreditCardRow>
                                <div style={{ paddingLeft: '16px' }}>
                                    <StripeContainer
                                        buttonIsDisabled={disableNextButton}
                                        onPayButtonSubmit={createACustomer()}
                                        buttonStyle={{
                                            position: 'relative',
                                            top: '250px',
                                            left: '50px',
                                        }}
                                        buttonLabel={
                                            isLoading ? (
                                                <CircularProgress
                                                    style={{
                                                        height: '20px',
                                                        width: '20px',
                                                        color: 'white',
                                                    }}
                                                    color="primary"
                                                />
                                            ) : (
                                                'Place Order'
                                            )
                                        }
                                    />
                                </div>
                            </CreditCardSection>
                            <br />
                            <br />
                            <TermsSection>
                                <Checkbox
                                    checked={billingTermsIsChecked}
                                    onChange={() =>
                                        setAboutYourBusinessData({
                                            ...aboutYourBusinessData,
                                            billingTermsIsChecked: !billingTermsIsChecked,
                                        })
                                    }
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <span style={{ fontSize: '11px' }}>
                                    I have read and agree to the website terms and conditions
                                </span>
                                <br />
                                <br />

                                <div style={{ fontSize: '13px', paddingLeft: '16px' }}>
                                    Your personal data will be used to process your order, support
                                    your experience throughout this website, and for other purposes
                                    described in our privacy policy.{' '}
                                </div>
                            </TermsSection>
                        </PaymentMethodSection>
                        {
                            <div
                                style={{
                                    marginTop: '8px',
                                    marginLeft: '16px',
                                    marginBottom: '8px',
                                    color: postData.error ? 'red' : 'green',
                                    fontSize: '13px',
                                }}
                            >
                                {postData.message && postData.message.length >= 1
                                    ? postData.message.map((item, idx) => (
                                          <div key={idx}>{item}</div>
                                      ))
                                    : postData.message}
                            </div>
                        }
                    </EnterPaymentInfoColumn>
                </EnterPaymentInfoBody>
            </EnterPaymentInfoContainer>
        </AboutYourBusinessViewContainer>
    );
};
TellUsAboutYourBusinessView.propTypes = {
    aboutYourBusinessData: propTypes.shape({}),
    setAboutYourBusinessData: propTypes.func,
    createNewAdvertiser: propTypes.func,
    createACustomer: propTypes.func,
    postData: propTypes.shape({ message: propTypes.array, error: propTypes.bool }),
    setPostData: propTypes.func,
    history: propTypes.shape({
        push: propTypes.func,
    }),
};

TellUsAboutYourBusinessView.defaultProps = {
    aboutYourBusinessData: {},
    createNewAdvertiser: () => {},
    postData: {},
    history: {},
    setAboutYourBusinessData: () => {},
    setPostData: () => {},
    createACustomer: () => {},
};

export default TellUsAboutYourBusinessView;
